import { Typography } from '@mui/material'
import { FormTextCollection } from './FormTextCollection'

export const FormTextCollectionPrint = (props) => {
  return (
    <Typography className='form-read-only-text'>
      <FormTextCollection {...props} />
    </Typography>
  )
}
